import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexDogWalkerPageHeader = ({
  page,
  hasLogoImage,
  hasBannerImage,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <div className={cn('p-fluid-4', { 'lg:pt-fluid-14': !forceMobile })}>
      <div className="ft-widget page-header-block ft-widget-wrapper rounded-[20px]! p-2">
        <div
          className={cn('relative', {
            'pt-fluid-28': !hasBannerImage,
          })}
        >
          <HeaderBanner
            media={page?.bannerMedia}
            className="h-fluid-80 w-full rounded-[12px]"
            {...props}
            style={
              hasLogoImage
                ? {
                    maskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0IiBoZWlnaHQ9IjE0NCIgdmlld0JveD0iMCAwIDE0NCAxNDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4yODUxNTYgMC4wMjgzMjAzVjE0My4wMjhIMTQzLjI4NUMxMzEuNjg4IDE0My4wMjggMTIyLjI4NSAxMzMuNjI2IDEyMi4yODUgMTIyLjAyOFYzNS4wMjgzQzEyMi4yODUgMjcuMjk2NCAxMTYuMDE2IDIxLjAyODMgMTA4LjI4NSAyMS4wMjgzSDIxLjI4NTJDOS42ODc1IDIxLjAyODMgMC4yODUxNTYgMTEuNjI2NSAwLjI4NTE1NiAwLjAyODMyMDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K')`,
                    maskRepeat: 'no-repeat',
                    maskPosition: '-1px calc(100% + 1px)',
                    maskComposite: 'exclude',
                    WebkitMaskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0IiBoZWlnaHQ9IjE0NCIgdmlld0JveD0iMCAwIDE0NCAxNDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4yODUxNTYgMC4wMjgzMjAzVjE0My4wMjhIMTQzLjI4NUMxMzEuNjg4IDE0My4wMjggMTIyLjI4NSAxMzMuNjI2IDEyMi4yODUgMTIyLjAyOFYzNS4wMjgzQzEyMi4yODUgMjcuMjk2NCAxMTYuMDE2IDIxLjAyODMgMTA4LjI4NSAyMS4wMjgzSDIxLjI4NTJDOS42ODc1IDIxLjAyODMgMC4yODUxNTYgMTEuNjI2NSAwLjI4NTE1NiAwLjAyODMyMDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K')`,
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskPosition: '-1px calc(100% + 1px)',
                    WebkitMaskComposite: 'exclude',
                  }
                : undefined
            }
          />

          <HeaderLogo
            media={page?.logoMedia}
            {...props}
            className="absolute bottom-0 left-0 rounded-[7px]"
            sizeClassName="size-[110px]"
            size={110}
          />
        </div>

        <div className="flex flex-col space-y-fluid-2 pt-fluid-5">
          <div className="ml-fluid-28">
            <HeaderName
              name={page?.name}
              {...props}
              className="text-fluid-3xl text-page-heading-text"
            />

            <HeaderDescription
              description={page?.description}
              {...props}
              className="pr-fluid-2 text-fluid-base"
            />
          </div>

          <HeaderSocialIcons
            socialIcons={page?.socialIcons}
            {...props}
            className="mt-fluid-5! w-full justify-center"
            primaryClassName="p-fluid-3 page-header-primary-button flex-1"
            secondaryClassName="p-fluid-3 page-header-secondary-button"
          />
        </div>
      </div>
    </div>
  )
}
